import type {
    ReactElement,
} from "preact/compat";

import {
    useViewerStore,
} from "../../stores/viewerStore.ts";

export const AiMetadataFilters = (): ReactElement => {
    const {
        filters,
        setFilters,
    } = useViewerStore();

    return (
        <div className="space-y-3">
            <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm text-text-secondary cursor-pointer">
                    <input
                        type="checkbox"
                        checked={filters.has_watermark === true}
                        onChange={(event) =>
                            setFilters({
                                has_watermark:
                                    (event.target as HTMLInputElement).checked
                                        ? true
                                        : undefined,
                            })}
                        className="rounded border-border"
                    />
                    Has watermark
                </label>
            </div>
        </div>
    );
};
